<h2 mat-dialog-title>Capabilities By Machine</h2>
<mat-dialog-content>
  <table border="0" cellpadding="1" cellspacing="0">
    <thead>
      <tr>
        <td>Machine</td>
        <td>{{data.name}}</td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cap of data.capabilities">
        <td class="key-col" title="{{cap.key}}">{{cap.key}}</td>
        <td class="val-col" title="{{cap.value}}">{{cap.value}}</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
